export { default as useFixedThead } from './useFixedThead';
